import styled from 'styled-components';

import { CheckCircle as MuiCheckCircle, Lock } from '@mui/icons-material';
import {
  Timeline as MuiTimeline,
  TimelineConnector as MuiTimelineConnector,
  timelineItemClasses,
  TimelineDot as MuiTimelineDot,
} from '@mui/lab';

export const LockIcon = styled(Lock)`
  height: 20px;
  width: 20px;
  fill: ${({ theme }) => theme.yoga.colors.text.disabled};
  margin-top: 12px;
`;

export const TimelineDot = styled(MuiTimelineDot)`
  height: 20px;
  width: 20px;
  border-color: ${({ theme }) => theme.palette.text.secondary};
`;

export const Timeline = styled(MuiTimeline)`
  padding: 0 !important;

  .${timelineItemClasses.root}:before {
    flex: 0;
    padding: 0;
  }
`;

export const CheckCircle = styled(MuiCheckCircle)`
  height: 20px;
  width: 20px;
  fill: ${({ theme }) => theme.palette.success.light};
  margin: 8px 0;
`;

export const TimelineConnector = styled(MuiTimelineConnector)`
  background-color: ${({ theme }) => theme.palette.text.secondary};
`;
